export const AG_GRID_LOCALE_RU = {
  // 🌐 General
  selectAll: 'Выбрать все',
  selectAllSearchResults: 'Выбрать все результаты поиска',
  addFilter: 'Добавить фильтр',
  clearFilter: 'Очистить фильтр',
  applyFilter: 'Применить фильтр',
  resetFilter: 'Сбросить',
  searchOoo: 'Поиск...',
  equals: 'Равно',
  notEqual: 'Не равно',
  lessThan: 'Меньше чем',
  greaterThan: 'Больше чем',
  greaterThanOrEqual: 'Больше или равно',
  lessThanOrEqual: 'Меньше или равно',
  inRange: 'В диапазоне',
  inRangeStart: 'В диапазоне (начало)',
  inRangeEnd: 'В диапазоне (конец)',
  contains: 'Содержит',
  notContains: 'Не содержит',
  startsWith: 'Начинается с',
  endsWith: 'Заканчивается на',
  before: 'До',
  after: 'После',
  andCondition: 'И',
  orCondition: 'Или',
  and: 'И',
  or: 'Или',
  not: 'Не',
  is: 'Является',
  isNot: 'Не является',
  isEmpty: 'Пусто',
  isNotEmpty: 'Не пусто',
  isNull: 'NULL',
  isNotNull: 'Не NULL',
  isBlank: 'Пусто',
  isNotBlank: 'Не пусто',

  // 🧮 Filter & Sorting
  filterOoo: 'Фильтр...',
  blanks: 'Пустые значения',
  blank: 'Пустое значение',
  notBlank: 'Не пустое значение',
  dateFormatOoo: 'yyyy-mm-dd',

  // 📋 Menu / Context
  copy: 'Копировать',
  paste: 'Вставить',
  export: 'Экспорт',
  csvExport: 'Экспорт CSV',
  excelExport: 'Экспорт Excel',

  // 📄 Pagination
  pageSizeSelectorLabel: 'Размер страницы',
  page: 'Страница',
  more: 'Больше',
  to: 'до',
  of: 'из',
  next: 'Следующая',
  last: 'Последняя',
  first: 'Первая',
  previous: 'Предыдущая',
  loadingOoo: 'Загрузка...',

  // 📊 Columns
  columns: 'Столбцы',
  filters: 'Фильтры',
  group: 'Группа',
  rowGroupColumnsEmptyMessage: 'Перетащите сюда столбцы для группировки',
  valueColumnsEmptyMessage: 'Перетащите сюда столбцы для значений',

  // 🔍 Other UI
  noRowsToShow: 'Нет данных для отображения',
  pinColumn: 'Закрепить столбец',
  autosizeThiscolumn: 'Автоматический размер',
  resetColumns: 'Сбросить столбцы',
  expandAll: 'Развернуть все',
  collapseAll: 'Свернуть все',

  // 🧭 Aggregation
  sum: 'Сумма',
  min: 'Минимум',
  max: 'Максимум',
  none: 'Нет',
  count: 'Количество',
  avg: 'Среднее',
}
